export const iconFontAwesomeMapsHelicopterSymbol = (
	<i className="fa-solid fa-helicopter-symbol"></i>
);
